import type { ComponentStyleConfig } from '@chakra-ui/react';

export const ModalComponentStyle: ComponentStyleConfig = {
  baseStyle: {
    overlay: {
      backgroundColor: 'rgba(0, 0, 0, 0.5)',
    },
  },
};
